import { render, staticRenderFns } from "./MdocksFormHeader.vue?vue&type=template&id=021357fe"
import script from "./MdocksFormHeader.vue?vue&type=script&lang=js"
export * from "./MdocksFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports